// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__1m9XV","text":"Error_text__yg4kD"};